import Footer from "./Footer";
import Header from "./Header";
import MainAfroNos from "./Main/MainAfroNos";

function AfroNos(params) {
    
    return(
        <div>
            <Header />
            <MainAfroNos />
            <Footer />
        </div>
    
    );
}
export default AfroNos;